import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Lock, CreditCard } from 'lucide-react';

export const SubscriptionLockedOverlay: React.FC = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <div className="flex flex-col items-center justify-center min-h-[50vh] p-4 animate-in fade-in zoom-in duration-300">
            <Card className="w-full max-w-md shadow-2xl border-red-200">
                <CardHeader className="text-center">
                    <div className="mx-auto bg-red-100 p-3 rounded-full w-fit mb-4">
                        <Lock className="h-8 w-8 text-red-600" />
                    </div>
                    <CardTitle className="text-2xl font-bold text-red-900">{t('subscriptions.locked.title')}</CardTitle>
                    <CardDescription className="text-red-700 font-medium mt-2">
                        {t('subscriptions.locked.subtitle')}
                    </CardDescription>
                </CardHeader>
                <CardContent className="space-y-6 text-center">
                    <p className="text-gray-600">
                        {t('subscriptions.locked.body')}
                    </p>

                    <div className="bg-muted p-4 rounded-lg">
                        <p className="text-sm text-muted-foreground mb-2">{t('subscriptions.locked.actions_required')}</p>
                        <ul className="space-y-2 text-sm text-left list-disc list-inside">
                            <li>{t('subscriptions.locked.action_renew')}</li>
                            <li>{t('subscriptions.locked.action_clear_dues')}</li>
                        </ul>
                    </div>

                    <Button
                        size="lg"
                        className="w-full gap-2 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white shadow-lg"
                        onClick={() => navigate('/subscriptions')}
                    >
                        <CreditCard className="h-4 w-4" />
                        {t('subscriptions.locked.renew_button')}
                    </Button>

                    <p className="text-xs text-muted-foreground mt-4">
                        {t('subscriptions.locked.need_help')}
                    </p>
                </CardContent>
            </Card>
        </div>
    );
};
